import { render, staticRenderFns } from "./AvisoIntegracaoTintometrica.vue?vue&type=template&id=086e0f98&scoped=true"
import script from "./AvisoIntegracaoTintometrica.vue?vue&type=script&lang=js"
export * from "./AvisoIntegracaoTintometrica.vue?vue&type=script&lang=js"
import style0 from "./AvisoIntegracaoTintometrica.vue?vue&type=style&index=0&id=086e0f98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086e0f98",
  null
  
)

export default component.exports